import ordersOneStryker from "../../api/ordersOneStryker";

export default {
  namespaced: true,
  state: {
    items: [],
    editedId: -1,
    details: [],
    editedItem: {
      customer: {},
      orderDate: "",
      orderNumber: "",
      status: "",
      totalAmount: "",
    },
    defaultItem: {
      customer: {},
      orderDate: "",
      orderNumber: "",
      status: "",
      totalAmount: "",
    },
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    setEditedItem(state, item) {
      const editedItem = {
        customer: item.customer,
        orderDate: item.orderDate,
        orderNumber: item.orderNumber,
        status: item.status,
        totalAmount: item.totalAmount,
      };
      state.editedItem = editedItem;
    },
    setEditedId(state, id) {
      state.editedId = id;
    },
    setDetails(state, details) {
      state.details = details;
    },
  },
  actions: {
    fetchAll({ commit }, data) {
      return ordersOneStryker.get(data).then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
    createOrder({ commit }, order) {
      return ordersOneStryker.createOrder(order).then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
    fetchCustommerCommands({ commit }, data) {
      return ordersOneStryker.getCommands(data).then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
    downloadInvoice({ commit }, id) {
      return ordersOneStryker.downloadInvoice(id).then((response) => {
        commit("setOverlay", false, { root: true });
        return response;
      });
    },
    getDetails({ commit }, id) {
      return ordersOneStryker.getDetails(id).then((response) => {
        commit("setDetails", response.data);
        return response;
      });
    },
    recalculateColumns() {
      return ordersOneStryker.recalculateColumns();
    },
    deleteOrder({ dispatch }, orderId) {
      return ordersOneStryker.deleteOrder(orderId).then((response) => {
        return dispatch("fetchAll").then(() => response);
      });
    },
    resetEditedItem({ commit, state }) {
      commit("setEditedId", -1);
      commit("setEditedItem", Object.assign({}, state.defaultItem));
    },
  },
};
